const Logo = () => (
  <div className="logo">
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 130.9 31.5"
      enableBackground="new 0 0 130.9 31.5"
    >
      <path
        fill="#009edb"
        d="M112.7,0c-6.8,0-12.4,5.5-12.4,12.4c0,6.8,5.5,12.4,12.4,12.4c6.8,0,12.4-5.5,12.4-12.4
	C125.1,5.5,119.5,0,112.7,0 M122.3,5.5c-0.6,0.4-1.3,0.8-2,1.2c-0.4-0.8-0.9-1.6-1.5-2.3c0.5-0.3,1-0.7,1.4-1
	C121.1,3.9,121.8,4.7,122.3,5.5 M117.1,1.4c1,0.4,1.9,0.9,2.8,1.6c-0.4,0.4-0.9,0.7-1.4,1c-0.6-0.7-1.3-1.3-2-1.9
	C116.7,1.8,116.9,1.6,117.1,1.4 M118.1,4.2c-0.7,0.4-1.4,0.6-2.1,0.9c-0.3-0.7-0.6-1.4-1-2c0.4-0.2,0.8-0.4,1.1-0.7
	C116.8,2.9,117.5,3.5,118.1,4.2 M116.6,1.2c-0.2,0.2-0.4,0.4-0.5,0.6c-0.7-0.4-1.3-0.8-2.1-1.1C114.9,0.7,115.8,0.9,116.6,1.2
	 M115.7,2.1c-0.3,0.2-0.6,0.4-0.9,0.5c-0.4-0.6-0.8-1.1-1.2-1.7C114.3,1.2,115,1.6,115.7,2.1 M112.9,1c0.5,0.5,0.9,1.1,1.3,1.8
	c-0.4,0.1-0.8,0.2-1.3,0.2V1z M112.9,3.5c0.5,0,1.1-0.1,1.6-0.3c0.4,0.6,0.7,1.3,1,2c-0.8,0.2-1.7,0.3-2.6,0.4V3.5z M112.4,1v2
	c-0.4,0-0.8-0.1-1.3-0.2C111.6,2.2,112,1.6,112.4,1 M110.7,2.6c-0.3-0.1-0.7-0.3-0.9-0.5c0.7-0.4,1.4-0.8,2.1-1.1
	C111.4,1.5,111,2,110.7,2.6 M111.4,0.6c-0.7,0.3-1.4,0.7-2.1,1.1c-0.2-0.2-0.4-0.4-0.5-0.6C109.6,0.9,110.5,0.7,111.4,0.6
	 M119.9,21.8c-1.6-0.9-1.7-2.2-1.6-2.6c0.1-0.5,0.4-0.3,0.6-0.3c1.1,0,2.2-0.3,3.6-1.8c1.6-1.6,2.1-5.2-0.4-7.5
	c-2.6-2.5-5.4-2.1-7.2,0.2c-0.4,0.5-1.3,0.8-2,0.8c-1.2,0-0.4,0.9-0.4,1.1c0,0.2-0.2,0.3-0.3,0.3c-0.4-0.1-0.2,0.5-0.2,0.6
	s-0.2,0.3-0.2,0.3c-0.5,0-0.4,0.4-0.3,0.6c0,0.1,0,0.3-0.2,0.4c-0.2,0.1-0.3,0.5-0.3,0.8c0,0.5,0.5,0.9,1.3,1.5
	c0.8,0.6,0.9,1.2,0.9,1.6c0,0.4,0.1,1.1,0.2,1.5c0.2,0.5,0.2,1.5-0.9,1.5c-1.4,0.1-3.8,1.1-4,1.2c-0.8,0.3-1.8,0.4-2.6,0.2
	c-0.4-0.3-0.8-0.6-1.2-1c-0.2-0.5,0.1-1.1,0.4-1.5c0.5,0.5,1.1,0.4,1.5,0.4c0.4,0,2.2-0.3,2.5-0.4c0.3-0.1,0.4-0.1,0.5,0
	c0.7,0.3,1.7,0.3,2.1-1c0.4-1.4-0.5-1-0.7-0.9c-0.1,0.1-0.3,0-0.2-0.1c0.2-0.3-0.1-0.3-0.2-0.3c-0.4,0-0.9,0.4-1,0.5
	c-0.2,0.1-0.3,0.1-0.4,0.1c-0.5-0.3-2,0.1-2.5-0.7c0-0.2-0.4-3.5-0.6-4.1c0-0.1-0.1-0.3,0.1-0.5c0.4-0.6,1.4,0,2,0
	c0.7,0,0.8-0.3,1-0.5c0.2-0.2,0.3-0.1,0.4-0.2c0.1-0.1,0-0.2,0-0.3c0-0.1,0.1,0,0.2-0.1c0.1-0.1,0-0.3,0-0.4
	c0.2-0.3,0.6-0.1,0.4-0.7c-0.1-0.4,0.1-0.8,0.3-1c0.3-0.4,1.6-2.2-0.6-4.1c-2.1-1.8-4.3-1.6-5.7-0.1c-1.4,1.5-0.7,3.7-0.6,4.3
	c0.1,0.6-0.3,1.1-0.8,1.3c-0.4,0.2-1.3,0.8-1.9,1.3c0.1-4.8,3-9,7.4-10.7c0.2,0.2,0.4,0.5,0.6,0.7c-0.5,0.4-1.6,1.3-1.6,1.3
	s0.1,0,0.3,0.1c0.1,0,0.3,0.1,0.3,0.1s0.9-0.8,1.4-1.1c0.3,0.3,0.7,0.5,1.1,0.7c-0.2,0.4-0.8,1.4-0.8,1.4s0.1,0.1,0.2,0.1
	c0.1,0.1,0.2,0.1,0.2,0.1s0.6-1.1,0.8-1.5c0.5,0.2,1,0.3,1.5,0.3v2c-0.3,0-1,0-1.3-0.1l-0.2,0l0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3l0,0
	l0,0c0.2,0,0.9,0,1.2,0v3.7h0.5V8.9c0.8,0,1.4-0.1,2.1-0.2l0,0l0.7-0.6l-0.4,0c-0.8,0.1-1.5,0.2-2.1,0.2c0,0-0.2,0-0.3,0V6
	c0.9,0,1.9-0.1,2.8-0.4c0.2,0.6,0.7,2.1,0.7,2.1l0.5-0.2c0,0-0.5-1.5-0.7-2.1c0.8-0.2,1.5-0.6,2.2-0.9c0.6,0.7,1.1,1.5,1.5,2.3
	c-0.4,0.2-1,0.4-1,0.4c0.5,0.1,0.9,0.2,0.9,0.2s0.2-0.1,0.3-0.1c0,0.1,0.1,0.3,0.1,0.3l0.7,0.3l-0.1-0.2c0,0-0.2-0.5-0.3-0.6
	c0.7-0.3,1.4-0.7,2.1-1.2c1.3,1.9,1.9,4.2,1.9,6.5C124.6,16.2,122.7,19.6,119.9,21.8"
      />
      <path
        fill="#009edb"
        d="M99.2,3.3L99,3.5c-0.7,0.6-2.4,2.3-2.1,4.2c0,0,0,0.1,0,0.1c0,0,0.1,0.4,0.1,0.4l0.2-0.2
	c1-0.9,1.8-2.5,2.1-4.3l0.1-0.5L99.2,3.3z"
      />
      <path
        fill="#009edb"
        d="M95.8,6.5l-0.1,0.2c-0.1,0.3-0.3,1-0.4,1.8c-0.2,1.2-0.1,3,0.9,4.3c0,0,0.1,0.2,0.1,0.2l0.1,0.2l0.2-0.8
	c0.2-1.4-0.1-4.3-0.6-5.6l-0.2-0.4L95.8,6.5z"
      />
      <path
        fill="#009edb"
        d="M94.6,11.5l0,0.2c-0.1,1.2,0,4.3,2.5,6c0,0,0.3,0.2,0.3,0.2l0-0.4c0-1.2-1.4-4.7-2.4-5.9l-0.3-0.4L94.6,11.5
	z"
      />
      <path
        fill="#009edb"
        d="M95,17l0,0.2c0.4,1.8,2,4.6,4.6,5.5l0.4,0.1l-0.1-0.4c-0.5-1.3-3-4.4-4.6-5.4L95,16.8L95,17z"
      />
      <path
        fill="#009edb"
        d="M100.3,6L100,6.1c-1.9,1.2-2.8,2.6-2.8,4.4l0,0.4l0.3-0.2c1-0.9,2.4-3.1,2.7-4.3l0.1-0.5L100.3,6z"
      />
      <path
        fill="#009edb"
        d="M99.1,9.8L99,10c-0.5,0.5-2.1,2.2-2,4.3c0,0.3,0.1,0.7,0.2,1l0.1,0.3l0.2-0.3c0.8-1.1,1.8-3.9,1.7-5.2l0-0.4
	L99.1,9.8z"
      />
      <path
        fill="#009edb"
        d="M99.2,13.5l-0.1,0.2c-0.8,1.2-1.2,2.4-1.2,3.6c0,0.8,0.3,1.6,0.8,2.4l0.2,0.3l0.1-0.3
	c0.3-0.7,0.6-2.8,0.6-4.5c0-0.6-0.1-1.1-0.2-1.4l-0.1-0.4L99.2,13.5z"
      />
      <path
        fill="#009edb"
        d="M100.1,17.4l-0.1,0.2c-0.2,0.8-0.4,1.5-0.3,2.3c0,1.6,0.8,2.9,2.2,3.8l0.2,0.1l0.1-0.3c0,0,0-0.3,0-0.3
	c0-1.3-1-4.7-1.8-5.7l-0.2-0.3L100.1,17.4z"
      />
      <path
        fill="#009edb"
        d="M97.4,22.6l0.1,0.2c1,1.7,2.8,4,6.1,3.4l0.3,0l-0.2-0.2c-0.6-0.9-4.6-3.2-6-3.4l-0.4-0.1L97.4,22.6z"
      />
      <path
        fill="#009edb"
        d="M102.3,27L102.3,27l-0.5,0.1l0.5,0.2c2.1,0.9,4.7,1.1,6.3,0.6c0.6-0.2,0.9-0.5,1.3-0.9
	c2.7,0.3,5.2,2.5,6.7,4.3c0,0,0.1,0.1,0.1,0.1l0.1,0c0.2-0.1,0.4-0.3,0.5-0.4l0.1-0.1l-0.1-0.1c-1.5-2-3.9-3.2-4-3.3
	C111.1,26.5,107.3,25.7,102.3,27"
      />
      <path
        fill="#009edb"
        d="M102.4,21.4l0,0.2c0.3,2,1.1,4.6,4.5,4.3l0.2,0l-0.1-0.2c-0.2-0.9-3.3-3.5-4.4-4.2l-0.3-0.2L102.4,21.4z"
      />
      <path
        fill="#009edb"
        d="M126,3.1l0.1,0.5c0.3,1.8,1.1,3.4,2.1,4.3l0.2,0.2c0,0,0.1-0.4,0.1-0.4c0,0,0-0.1,0-0.1
	c0.3-1.9-1.4-3.6-2.1-4.2l-0.2-0.2L126,3.1z"
      />
      <path
        fill="#009edb"
        d="M129.5,6.3l-0.2,0.4c-0.5,1.3-0.7,4.2-0.6,5.6l0.2,0.8L129,13c0,0,0.1-0.2,0.1-0.2c1.1-1.3,1.1-3,0.9-4.3
	c-0.1-0.9-0.3-1.5-0.4-1.8l-0.1-0.2L129.5,6.3z"
      />
      <path
        fill="#009edb"
        d="M130.8,11.3l-0.3,0.4c-1,1.3-2.4,4.7-2.4,5.9l0,0.4c0,0,0.3-0.2,0.3-0.2c2.5-1.6,2.6-4.7,2.5-6l0-0.2
	L130.8,11.3z"
      />
      <path
        fill="#009edb"
        d="M130.4,16.8l-0.4,0.2c-1.6,1-4.1,4.1-4.6,5.4l-0.1,0.4l0.4-0.1c2.6-0.8,4.3-3.7,4.6-5.5l0-0.2L130.4,16.8z"
      />
      <path
        fill="#009edb"
        d="M125.1,5.8l0.1,0.5c0.4,1.3,1.6,3.5,2.7,4.4l0.3,0.2l0-0.4c0.1-1.8-0.8-3.2-2.7-4.4l-0.2-0.1L125.1,5.8z"
      />
      <path
        fill="#009edb"
        d="M126.2,9.7l0,0.4c-0.1,1.3,1,4.2,1.7,5.2l0.2,0.3l0.1-0.3c0.1-0.4,0.2-0.7,0.2-1c0.1-2.1-1.5-3.8-2-4.3
	l-0.1-0.1L126.2,9.7z"
      />
      <path
        fill="#009edb"
        d="M126.1,13.3l-0.1,0.4c-0.1,0.3-0.2,0.8-0.2,1.4c0,1.7,0.2,3.8,0.6,4.5l0.1,0.3l0.2-0.3
	c0.5-0.7,0.8-1.5,0.8-2.4c0-1.1-0.4-2.4-1.2-3.6l-0.1-0.2L126.1,13.3z"
      />
      <path
        fill="#009edb"
        d="M125.2,17.2l-0.2,0.3c-0.8,1-1.8,4.4-1.8,5.7c0,0,0,0.2,0,0.3l0.1,0.3c0,0,0.2-0.1,0.2-0.1
	c1.4-0.9,2.1-2.2,2.2-3.8c0-0.7-0.1-1.5-0.3-2.3l-0.1-0.2L125.2,17.2z"
      />
      <path
        fill="#009edb"
        d="M128.1,22.4c0,0-0.4,0.1-0.4,0.1c-1.4,0.2-5.4,2.5-6,3.4l-0.2,0.2l0.3,0c3.3,0.6,5.1-1.7,6.1-3.4l0.1-0.2
	L128.1,22.4z"
      />
      <path
        fill="#009edb"
        d="M112.2,27.5c-0.1,0-2.5,1.3-4,3.3l-0.1,0.1l0.1,0.1c0.1,0.1,0.4,0.3,0.5,0.4l0.1,0c0,0,0.1-0.1,0.1-0.1
	c1.5-1.8,4-4.1,6.7-4.3c0.4,0.4,0.8,0.7,1.3,0.9c1.5,0.5,4.2,0.3,6.3-0.6l0.5-0.2l-0.5-0.1C118.1,25.7,114.3,26.5,112.2,27.5"
      />
      <path
        fill="#009edb"
        d="M123,21.2l-0.3,0.2c-1.1,0.7-4.1,3.3-4.4,4.2l-0.1,0.2l0.2,0c3.3,0.3,4.1-2.3,4.5-4.3l0-0.2L123,21.2z"
      />
      <path
        fill="#009edb"
        d="M38.6,1.2h4.2V5h-4.2V1.2z M39,9.4h3.5v18.6H39V9.4z"
      />
      <path
        fill="#009edb"
        d="M12.5,9.4H16v18.6h-3.4v-2.7h-0.1c-1.4,2.3-3.8,3.3-6.4,3.3c-3.9,0-6.1-3-6.1-6.7V9.4h3.5v11
	c0,3.2,0.7,5.6,4.1,5.6c1.4,0,3.4-0.7,4.1-2.7c0.7-1.7,0.7-3.9,0.7-4.4V9.4z"
      />
      <path
        fill="#009edb"
        d="M23,12.1L23,12.1c1.3-2.3,3.8-3.3,5.7-3.3c1.3,0,7,0.3,7,6.3v12.8h-3.5V16.2c0-3.1-1.3-4.7-4.3-4.7
	c0,0-1.9-0.1-3.4,1.4c-0.5,0.5-1.5,1.3-1.5,5v10.1h-3.5V9.4H23V12.1z"
      />
      <path
        fill="#009edb"
        d="M57.2,15.3c-0.2-2.3-1.3-3.9-3.8-3.9c-3.3,0-4.6,2.9-4.6,7.2c0,4.3,1.3,7.2,4.6,7.2c2.3,0,3.7-1.5,3.9-4.2
	h3.5c-0.3,4.2-3.4,6.7-7.5,6.7c-5.9,0-8.3-4.2-8.3-9.6c0-5.4,2.7-9.9,8.6-9.9c3.9,0,6.8,2.5,7,6.5H57.2z"
      />
      <path
        fill="#009edb"
        d="M66,19.3c-0.3,3.2,1.1,6.6,4.6,6.6c2.7,0,4.1-1.1,4.5-3.8h3.7c-0.6,4.2-3.8,6.3-8.2,6.3
	c-5.9,0-8.3-4.2-8.3-9.6c0-5.4,2.7-9.9,8.6-9.9C76.4,9,79,12.5,79,17.6v1.7H66z M75.4,16.9c0.1-3.1-1.3-5.5-4.7-5.5
	c-2.9,0-4.6,2.5-4.6,5.5H75.4z"
      />
      <path
        fill="#009edb"
        d="M83,27.8v-16h-3.2V9.4H83v-4c0.1-4,3.2-5.1,5.8-5.1c0.8,0,1.7,0.2,2.5,0.4v2.9c-0.6,0-1.2-0.1-1.8-0.1
	c-2,0-3.1,0.5-3,2.5v3.4h4.3v2.4h-4.3v16H83z"
      />
    </svg>
  </div>
);

export default Logo;
